import type { AppLocale } from "@/lib/i18n/constants";
import type { ContentObject, DeepContentPartial } from "@/lib/content/types";
import arOverrides from "./ar/overrides.json";
import deOverrides from "./de/overrides.json";
import esOverrides from "./es/overrides.json";
import frOverrides from "./fr/overrides.json";
import hiOverrides from "./hi/overrides.json";
import heOverrides from "./he/overrides.json";
import idOverrides from "./id/overrides.json";
import itOverrides from "./it/overrides.json";
import jaOverrides from "./ja/overrides.json";
import koOverrides from "./ko/overrides.json";
import ptBrOverrides from "./pt-br/overrides.json";
import ruOverrides from "./ru/overrides.json";
import trOverrides from "./tr/overrides.json";
import zhCnOverrides from "./zh-cn/overrides.json";

type OverridesByContentKey = Record<string, DeepContentPartial<ContentObject>>;

export const CONTENT_LOCALE_OVERRIDES = {
  ar: arOverrides as OverridesByContentKey,
  de: deOverrides as OverridesByContentKey,
  es: esOverrides as OverridesByContentKey,
  fr: frOverrides as OverridesByContentKey,
  hi: hiOverrides as OverridesByContentKey,
  he: heOverrides as OverridesByContentKey,
  id: idOverrides as OverridesByContentKey,
  it: itOverrides as OverridesByContentKey,
  ja: jaOverrides as OverridesByContentKey,
  ko: koOverrides as OverridesByContentKey,
  "pt-br": ptBrOverrides as OverridesByContentKey,
  ru: ruOverrides as OverridesByContentKey,
  tr: trOverrides as OverridesByContentKey,
  "zh-cn": zhCnOverrides as OverridesByContentKey,
} satisfies Partial<Record<AppLocale, OverridesByContentKey>>;
